<template>
  <div>
    <dv-active-ring-chart :config="config" style="width: 100%; height: 175px" />
  </div>
</template>
<script>
export default {
  data() {
    return {
      config: {
        showOriginValue: true,
        digitalFlopStyle: {
          fontSize: 14,
        },
        lineWidth: 12,
        radius: '87%',
        activeRadius: '92%',
        color: ['#37a2da', '#ffdb5c', '#9d96f5'],
        data: [
          {
            name: '生产企业数',
            value: 758,
          },
          {
            name: '合作社数',
            value: 502,
          },
          {
            name: '家庭农场数',
            value: 1726,
          },
        ],
      },
    }
  },
}
</script>


// WEBPACK FOOTER //
// src/components/screen28896/administration-zone/entity-mode-ratio.vue